import './style.scss';
import {gsap} from 'gsap';
import {isRTL} from '../../scripts/isRTL';

export function contact_us_block() {
  const block = document.querySelector('.contact_us_block');
  if (!block) return;
  const header = document.querySelector('header');
  const svg = block.querySelector('.form-svg');
  const form = block.querySelector('.form-wrapper');
  gsap.timeline({delay: 1.5})
      .from(form, {opacity: 0, duration: 1})
      .from(svg, {zoom: 2, duration: 1}, 0)
      .from(header, {opacity: 0, yPercent: -100, duration: 1}, 0)
      .fromTo(svg, {
        bottom: '50%',
        left: '50%',
        right: 'unset',
        xPercent: -50,
        yPercent: 50,
        x: 0,
        y: 0,
        scaleX: isRTL() ? -1 : 1,
        rotation: 0,
        ease: 'power2.out',
      }, {
    
        scaleX: isRTL() ? -1 : 1,
        rotation: 0,
        bottom: '50%',
        left: () => document.body.matches('.rtl') ? '0' : '100%',
        right: 'unset',
        xPercent: () => document.body.matches('.rtl') ? -101 : 1,
        yPercent: 50,
        x: 0,
        y: 0,
        ease: 'power2.in',
        duration: 1.5,
      })
      .to(svg, {
        zIndex: -1,
        xPercent: () => document.body.matches('.rtl') ? -20 : -80, duration: 3,
      })
      .from(form.children, {opacity: 0, duration: 3}, '<')
  ;
  gsap.set(svg, {zIndex: 2});
  // .from(wrapper,{scale:2, transformOrigin:'top'},'<')
  
}
